
export enum ObjectTagValuesMode {
    Values = 0,
    ManualEntry = 1
}
